
// src/connects/kpi-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage } from '../helpers/analytics'
import find from 'lodash/find'

export const mapStateToProps = (state, ownProps)=> {
  return {
    group: state.groups.items && find(state.groups.items, (item)=> item.group_id == ownProps.params.group_id) || undefined,
    kpis: state.kpi.items,
    closedKpis: state.kpi.closedItems,
    isFetching: state.kpi.isFetching,
    hasMoreClosedKpis: state.kpi.hasMoreClosedItems,
    scrollPosition: state.kpi.scrollPosition || undefined,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    fetchKpis: (props)=> dispatch(actions.fetchKpis(props.params.group_id)),
    fetchClosedKpis: (props, refresh = false)=> dispatch(actions.fetchClosedKpis(props.params.group_id, refresh ? 0 : props.closedKpis && props.closedKpis.length || 0)),
    willMount: (props)=> {
      if(props.closedKpis){
        props.updateUI({ showClosedKpi: true })
      }
      dispatch(actions.fetchKpis(props.params.group_id))
    },
    willUnmount: (props)=> {
      if(!props.ui.showKpiChart){
        dispatch(actions.clearKpis())
      } 
    },
    openKPIChartPage: (props, kpi_id, closedKpis, offset)=> {
      if(closedKpis){
        props.updateUI({ showKpiChart: true })
        offset && dispatch(actions.keepScrollPosition(offset))
      }
      dispatch(actions.openRightSidePage('kpi_chart', { kpi_id, group_id: props.params.group_id }, true))
    },
    openGroupKPIPanel: ()=> dispatch(actions.openGroupSettingsPage('kpi')),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: { showClosedKpi: false, showKpiChart: false }}),
  lifecycle,
  translate(),
  trackPage('kpi'),
)



// WEBPACK FOOTER //
// ./src/connects/kpi-page.js